import React, { useState } from 'react';
import { Content, Header } from '@backstage/core-components';
import { AssignIdentityDrawer } from '../components/AssignIdentityDrawer/AssignIdentityDrawer';
import { IdentitiesGrid } from '../components/IdentitiesGrid/IdentitiesGrid';
import { Identity } from '../components/IdentitiesGrid/types';

export default function IdentitiesPage() {
  const [identityToAssign, setIdentityToAssign] = useState<Identity | null>(null);

  function handleDrawerClose() {
    setIdentityToAssign(null);
  }

  return (
    <>
      <Header
        title="Identities"
        subtitle="Manage human and machine identities"
      />
      <Content>
        <IdentitiesGrid onAssign={setIdentityToAssign} />
      </Content>
      <AssignIdentityDrawer
        identity={identityToAssign}
        isOpen={Boolean(identityToAssign)}
        handleDrawerClose={handleDrawerClose}
      />
    </>
  );
}
